import React from "react";
import GlobalStyles from "./settings/globalStyles";

import { Router } from "react-router";
import Routes from "./routes";

import history from "./services/history";

import { Provider } from "react-redux";
import { store, persistor } from "./store";
import { PersistGate } from "redux-persist/integration/react";

function App() {
    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <GlobalStyles />

                <Router history={history}>
                    <Routes />
                </Router>
            </PersistGate>
        </Provider>
    );
}

export default App;
